import actionCreatorFactory from 'typescript-fsa';

import * as api from '../api';
import * as store from './store';
import { getI18n } from 'react-i18next';
import { changeGlobalMomentLocale } from '../i18n';

const actionCreator = actionCreatorFactory();

export const setHeaderHidden = actionCreator<boolean>('SET_HEADER_HIDDEN');
export function setHeaderHiddenHandler(
  state: store.All,
  isHeaderHidden: boolean,
): store.All {
  return {
    ...state,
    isHeaderHidden,
  };
}

export const setTheme = actionCreator<api.PracticeTheme.ThemeResponse | null>(
  'SET_THEME',
);
export function setThemeHandler(
  state: store.All,
  theme: api.PracticeTheme.ThemeResponse | null,
): store.All {
  return { ...state, theme };
}

export const setDocumentTitle = actionCreator<string | null>(
  'SET_DOCUMENT_TITLE',
);
export function setDocumentTitleHandler(
  state: store.All,
  documentTitle: string | null,
): store.All {
  return { ...state, documentTitle };
}

export const setPreferredLanguage = actionCreator<store.Language>(
  'SET_PREFERRED_LANGUAGE',
);
export function setPreferredLanguageHandler(
  state: store.All,
  preferredLanguage: store.Language,
): store.All {
  if (preferredLanguage === api.Language.Language.En) {
    localStorage.removeItem('preferredLanguage');
  } else {
    localStorage.setItem('preferredLanguage', preferredLanguage);
  }

  getI18n().changeLanguage(preferredLanguage);
  changeGlobalMomentLocale(preferredLanguage);

  return { ...state, preferredLanguage };
}

export const setOnCaptchaSuccess = actionCreator<(() => void) | null>(
  'SET_ON_CAPTCHA_SUCCESS',
);
export function setOnCaptchaSuccessHandler(
  state: store.All,
  onCaptchaSuccess: (() => void) | null,
): store.All {
  return {
    ...state,
    onCaptchaSuccess,
  };
}
